// extracted by mini-css-extract-plugin
export default {"carDiagnosisTable":"carDiagnosisTable_carDiagnosisTable__eyCBC","aebTitle":"carDiagnosisTable_aebTitle__IONX1"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"carDiagnosisTable\":\"carDiagnosisTable_carDiagnosisTable__eyCBC\",\"aebTitle\":\"carDiagnosisTable_aebTitle__IONX1\"}";
        // 1793842504262
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  